import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const ForceUpdateEvent = BaseLoanEvent.extend({
  type: z.literal('forceUpdate'),
  /**
   * The snapshot configuration to use for the force update.
   * If omitted, the existing snapshot configuration will be used (useful for recalculating derived fields
   * without overwriting the current state).
   */
  snapshotConfig: z.any().optional(), // LoanSnapshotConfig
  comment: z.string().optional(),
  rebuildLoanTransactionData: z.boolean().optional(),
});
export type ForceUpdateEvent = z.infer<typeof ForceUpdateEvent>;
